import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-help-glossaries',
  templateUrl: './help-glossaries.component.html'
})
export class HelpGlossariesComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private router: Router, private sanitizer: DomSanitizer) {
    
  }
  glossaries_header;
  glossaries_desc;
  glossaries_para1heading;
  glossaries_para1body;
  glossaries_para2heading;
  glossaries_para2body;
  glossaries_para3heading;
  glossaries_para3body;
  glossaries_para4body;
  isrightoverly;
  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();

    this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.gethelpglossarieslabels();
  }
  gethelpglossarieslabels() {

    this.graphQlService.gethelpglossariesLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.glossaries_header = labels.filter(x => x.key == "glossaries_header").map(y => y.value);
        this.glossaries_desc = labels.filter(x => x.key == "glossaries_desc").map(y => y.value);
        this.glossaries_para1heading = labels.filter(x => x.key == "glossaries_para1heading").map(y => y.value);
        this.glossaries_para1body = labels.filter(x => x.key == "glossaries_para1body").map(y => y.value);
        this.glossaries_para2heading = labels.filter(x => x.key == "glossaries_para2heading").map(y => y.value);
        this.glossaries_para2body = labels.filter(x => x.key == "glossaries_para2body").map(y => y.value);
        this.glossaries_para3heading = labels.filter(x => x.key == "glossaries_para3heading").map(y => y.value);
        this.glossaries_para3body = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "glossaries_para3body").map(y => y.value));
        this.glossaries_para4body = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "glossaries_para4body").map(y => y.value));

        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  openlink(event) {
    let id = event.target.id;
    if (id != "") {
      this.router.navigateByUrl(event.target.id);
    }
   
  }

}
